import { render } from "./newEnrolmentClass.vue?vue&type=template&id=a29f2b3a&scoped=true"
import script from "./newEnrolmentClass.vue?vue&type=script&lang=js"
export * from "./newEnrolmentClass.vue?vue&type=script&lang=js"

import "./newEnrolmentClass.vue?vue&type=style&index=0&id=a29f2b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a29f2b3a"]])

export default __exports__